//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import IconView from "@/components/objects/IconView.vue";
import TheRadarBadge from "@/components/TheRadarBadge.vue";
import TheRadarMonthBadge from "@/components/TheRadarMonthBadge.vue";
import TheRadarIsiBadge from "@/components/TheRadarIsiBadge";
import TheRadarTopFiftyBadge from "@/components/TheRadarTopFiftyBadge";

export default {
  name: "MainAbout",
  components: { IconView, TheRadarBadge, TheRadarMonthBadge, TheRadarIsiBadge, TheRadarTopFiftyBadge },
  data() {
    return {
      blocks: [
        {
          id: 0,
          image: "about2",
          label: "Интерактив и познавательный контент",
          tags:[
            {
              icon: "single-image-with-poly",
              label: "Иллюстрации"
            },
            {
              icon: "scheme",
              label: "Схемы"
            },
            // {
            //   icon: "has-attrs",
            //   label: "Списки"
            // },
            {
              icon: "calendar",
              label: "Таймлайны"
            },
            // {
            //   icon: "has-map",
            //   label: "Авторские карты"
            // },
            {
              icon: "facts",
              label: "Факты"
            },
          ],
          tags2:[
            {
              icon: "menu-articles",
              label: "Статьи"
            },
            {
              icon: "menu-objects",
              label: "Объекты"
            },
          ],
          button:{
            label: "Узнать больше"
          }
        },
        {
          id: 1,
          image: "stats",
          label: "Наша статистика за 30 дней",
          stats: [
            {
              icon: "growth",
              number: "",
              text: "",
            },
            {
              icon: "eye",
              number: "",
              text: "",
            },
            {
              icon: "",
              number: "",
              text: "",
            },
            {
              icon: "",
              number: "",
              text: "",
              type: "",
            }
          ],
          button:{
            action: () => {
              if (this.$auth.loggedIn) {
                this.$message.info('Вы уже являетесь автором')
              } else {
                this.$store.dispatch('auth_modals/showAuthModal', true)
              }
            },
            label: "Стать автором"
          }
        },
      ],
    }
  },

  computed: {
    footerStats() {
      return this.$store.getters['objects/getFooterStats'];
    },
  },

  mounted() {
    if (this.footerStats) {
      this.blocks[1].stats[0].number = `+ ${this.formattedNumber(this.footerStats.objects_total + this.footerStats.materials_total)}`
      this.blocks[1].stats[0].text = 'Новых объектов и статей'
      this.blocks[1].stats[1].number = `+ ${this.formattedNumber(this.footerStats.objects_views + this.footerStats.materials_views)}`
      this.blocks[1].stats[1].text = 'Новых просмотров статей и объектов'
      this.blocks[1].stats[2].icon = this.footerStats.top_author.profile?.icon
      this.blocks[1].stats[2].number = `+ ${this.formattedNumber(this.footerStats.top_author_views)}`
      this.blocks[1].stats[2].text = this.footerStats.top_author.profile?.nickname ?? this.footerStats.top_author.username

      if (this.footerStats.materials_top_views > this.footerStats.objects_top_views) {
        this.blocks[1].stats[3].number = `+ ${this.formattedNumber(this.footerStats.materials_top_views)}`
        this.blocks[1].stats[3].text = this.footerStats.materials_top.label
        this.blocks[1].stats[3].type = 'art'
      } else {
        this.blocks[1].stats[3].icon = this.footerStats.objects_top?.user?.profile?.icon
        this.blocks[1].stats[3].number = `+ ${this.formattedNumber(this.footerStats.objects_top_views)}`
        this.blocks[1].stats[3].text = this.footerStats.objects_top.label
        this.blocks[1].stats[3].type = 'object'
      }
    }
  },

  methods: {
    formattedNumber(number) {
      if (number >= 1000) {
        const fixedNumber = (number / 1000).toFixed(1)
        if (fixedNumber[fixedNumber.length - 1] === '0') {
          return fixedNumber.slice(0, -2) + 'К'
        } else {
          return `${(number / 1000).toFixed(1)}К`
        }
      } else {
        return `${number}`
      }
    }
  }
}
